import { skipToken, useQuery } from '@tanstack/react-query';

import { CatenaLinkedFleet } from '~hooks/useCatena/models';
import useCatena from '~hooks/useCatena/useCatena';
import { PaginationLink } from '~services/pagination';

const EMPTY_LINKED_FLEETS: CatenaLinkedFleet[] = [];

export const CATENA_LINKED_FLEETS_QUERY_KEY = 'catenaLinkedFleets';

export const catenaLinkedFleetsQueryKey = (
  companyId: string,
  direction?: PaginationLink,
  cursor?: string,
) => [CATENA_LINKED_FLEETS_QUERY_KEY, companyId, direction ?? null, cursor ?? null];

interface UseCatenaLinkedFleetsQueryProps {
  companyId: string;
  cursor?: string;
  direction?: PaginationLink;
}

export default function useCatenaLinkedFleetsQuery({
  companyId,
  cursor,
  direction,
}: UseCatenaLinkedFleetsQueryProps) {
  const { listLinkedFleets } = useCatena();

  const { data, isError, isLoading } = useQuery({
    queryKey: catenaLinkedFleetsQueryKey(companyId, direction, cursor),
    queryFn: companyId
      ? async ({ signal }) => {
          const page = await listLinkedFleets({ cursor, link: direction, signal });
          if (!page) throw new Error('Failed to fetch Catena linked fleets');

          return page;
        }
      : skipToken,
    // listLinkedFleets already toasts the failure; a retry would toast it again.
    retry: false,
  });

  return {
    isError,
    isLoading,
    linkedFleets: data?.data ?? EMPTY_LINKED_FLEETS,
    pagination: data?.pagination,
  };
}
